import { useMemo, useState } from 'react';
import { useConsultationAvailableTimes } from '../hooks';
import { AvailableTimes } from 'domains/calendars/types';

type UseConsultationCalendar = (params: { queryFrom: Date }) => {
  isLoading: boolean;
  currentTimeSlots?: Date[];
  data?: AvailableTimes;
  dayIndex: number;

  onChangeDay: (dayIndex: number) => void;
};

export const useConsultationCalendar: UseConsultationCalendar = ({ queryFrom }: { queryFrom: Date }) => {
  const [dayIndex, setDayIndex] = useState<number>(0);

  const { data: availableTimes, isLoading } = useConsultationAvailableTimes(queryFrom);

  const onChangeDay = (newDayIndex: number) => {
    setDayIndex(newDayIndex);
  };

  const currentDaySlots = useMemo(() => {
    if (!availableTimes) return undefined;
    return availableTimes[dayIndex].availableTimes;
  }, [availableTimes, dayIndex]);

  return {
    dayIndex: dayIndex,
    onChangeDay,
    currentTimeSlots: currentDaySlots,
    data: availableTimes,
    isLoading,
  };
};
